import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user } = useAuth();

  // Si aucun rôle n'est spécifié, autoriser tous les utilisateurs connectés
  if (allowedRoles.length === 0) {
    return user ? children : <Navigate to="/login" replace />;
  }

  // Vérifier si l'utilisateur a un rôle autorisé
  if (user && allowedRoles.includes(user.role)) {
    return children;
  }

  // Rediriger vers la page d'accueil si l'utilisateur n'a pas le bon rôle
  return <Navigate to="/app/ouvertures-classes" replace />;
};

export default ProtectedRoute;